import __request__ from "routing/request";
export function getLastOpened(page = 1, per_page = 5, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/startpage/lastOpened", null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRecentActivity(page = 1, per_page = 5, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/startpage/recentActivity", null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
